import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { ReportsService } from "../services/reports.service";


@Component({
  selector: 'app-portfolio-balance',
  templateUrl: './portfolio-balance.component.html',
  styleUrls: ['./portfolio-balance.component.scss']
})

export class PortfolioBalanceComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  currentUser: any;
  FyearId: any;
  maxDate: any;
  minDate: any;
  DataSource: MatTableDataSource<any>;
  ExportDataSource: MatTableDataSource<any>; 
  showSpinner: boolean = false;
  displayedColumns: string[] = [
  '#',
  'Application_No',
  'LoanAcNo',
  'Customer_Name',
  'Branch_Name',
  'Product_Name',
  'OpeningBalance',
  'AdditionalBalance',
  'ReceivedBalance',
  'ClosingBalance'
];


  FromDate: any = new Date(new Date().getFullYear(), new Date().getMonth(), 1); 
  ToDate: any = new Date(); 
  configSuccess : MatSnackBarConfig = {
      panelClass: "style-success",
      duration: 5000,
      horizontalPosition: "right",
      verticalPosition: "top",
    };
  constructor(
    private route: ActivatedRoute,
        private dataSharingService: DataSharingService,
        private reportsService: ReportsService,
        private MasterService: MasterService,
        private snackBar: MatSnackBar,
        private lmsService: LmsService
  ) {
   }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next("Portfolio Balance");
  }

  onsearchemidetails() {
    this.showSpinner = true;
    this.reportsService
      .Get_Portfolio_Balance({
        FromDate: this.FromDate,
        ToDate: this.ToDate,
        
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.DataSource = new MatTableDataSource(
            JSON.parse(JSON.stringify(res))
          );
          this.DataSource.sort = this.sort;
          this.DataSource.paginator = this.paginator;
          this.ExportDataSource = new MatTableDataSource(res); 
          this.showSpinner = false;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.showSpinner = false;
          this.DataSource = null;
        }
      });
  }

  applyFilter(filterValue: string) {
    if (this.DataSource) { 
      this.DataSource.filter = filterValue.trim().toLowerCase();
    }
    if (this.ExportDataSource) {
      this.ExportDataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  totaltypewise(type: string): number {
    if (this.DataSource && this.DataSource.filteredData) {
      let sum = 0;
      for (let i = 0; i < this.DataSource.filteredData.length; i++) {
        sum += Number(this.DataSource.filteredData[i][type] || 0);
      }
      return sum;
    }
    return 0;
  }
                    
    exportTable(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `portfolio-balance`,
      sheet: "portfolio-balance",
    });
  }
}
  
